import React, { useCallback, useContext, useEffect, useMemo, useState, useRef } from "react";
import { connect } from "dvajs";
import { UserState } from "@/models/user";
import styles from "./index.module.less";
import IconFont from "@/components/icon";
import { EbookState } from "@/models/ebook";
import { getPcSideConfig, PC_SIDE_ITEM_MAX, PC_SIDE_ITEM_NUM, PC_SIDEBAR_KEY } from "@/utils/tools";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import ThemeIcon, { ThemeType } from "@/layout/ThemeIcon";
// import { IconFont } from "@/components/icon";

/**
 *
 * 更多导航
 * @returns
 */
function NavSettingButton(props: any) {
  const { updateNavPopInfo, teamConfig, newContactsCount } = props;
  const { appRuntimeEnv } = useContext<GlobalContextConfig>(GlobalContext);
  const btnRef = useRef<any>(null);
  const showPop = useCallback(
    (ev) => {
      updateNavPopInfo({
        visible: true,
        editing: false,
        left: 74,
        top: ev.clientY
      });
    },
    [updateNavPopInfo]
  );

  const navMoreBtn = (
    <div
      className={`focus-nav-item ${styles["nav-setting-btn-wrap"]}`}
      onClick={showPop}
      ref={btnRef}
    >
      <div className={styles["more_btns"]}>
        <ThemeIcon name="More" theme={props.themes} />
      </div>

      <span className={styles["name"]}>更多</span>
    </div>
  );

  return navMoreBtn;
}

function mapStateToProps({ user, ebook }: { user: UserState; ebook: EbookState }) {
  return {
    navPopInfo: user.navPopInfo,
    teamConfig: user.teamConfig,
    newContactsCount: ebook.newContactsCount,
    pcFuncInfoMap: user.pcFuncInfoMap,
    themes: user.themes
  };
}

function mapDispatchToProps(dispatch: any) {
  return {
    updateNavPopInfo(payload: any) {
      dispatch({ type: "user/updateNavPopInfo", payload });
    },
    updateTeamConfig(payload: any) {
      dispatch({ type: "user/updateTeamConfig", payload });
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(NavSettingButton);
